module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_7016.b3a4df4d.png";